import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-action-dialog',
  templateUrl: './action-dialog.component.html',
  styleUrls: ['./action-dialog.component.css']
})
export class ActionDialogComponent implements OnInit {
  public buttonActions: any;
  public message: any;
  constructor(@Inject(MAT_DIALOG_DATA) public config: any, public dialogRef: MatDialogRef<ActionDialogComponent>) {
    this.buttonActions = config.buttonActions;
    this.message = config.message;
  }

  ngOnInit() {
  }

  public done() {
    this.dialogRef.close();
  }

}
